// import 'react-dates/initialize';
// import 'react-dates/lib/css/_datepicker.css';

const base = ({ isInvalid }) => ({
  '.DateRangePicker': {
    fontFamily: 'Poppins',
  },
  '.CalendarMonth_caption': {
    select: {
      background: 'gray.50',
      fontSize: 'md',
      padding: '3px 5px',
    },
  },
  '.DayPicker_weekHeader': {
    fontWeight: '600',
  },
  '.DayPicker_weekHeader_ul': {
    fontSize: 'xs',
  },
  '.DateRangePickerInput': {
    height: '8',
  },
  '.DateRangePickerInput__withBorder': {
    border: 'light',
    borderColor: 'border.base',
    borderRadius: '4px',
  },
  '.DateRangePickerInput .DateInput_input__focused': {
    borderWidth: 1,
    borderColor: 'secondary.tint',
  },
  '.DateInput': {
    height: '100%',
    background: 'transparent',
  },
  '.SingleDatePickerInput .DateInput': {
    width: '100%',
  },
  '.SingleDatePicker': {
    height: '100%',
    width: '100%',
  },
  '.SingleDatePicker_picker': {
    zIndex: 2,
    top: '54px !important',
  },
  '.DateRangePicker_picker': {
    zIndex: 2,
  },
  '.SingleDatePickerInput': {
    width: '100%',
    height: '100%',
    fontFamily: 'Poppins',
    border: 'none',
  },
  '.SingleDatePickerInput_calendarIcon': {
    height: '100%',
    position: 'absolute',
    right: 0,
    margin: 0,
    padding: '12px 8px 8px',
    backgroundColor: 'gray.100',
    border: 'light',
    borderRightRadius: 'base',
    borderColor: isInvalid ? 'error' : 'border.base',
  },
  '.SingleDatePickerInput:hover .SingleDatePickerInput_calendarIcon': !isInvalid && {
    borderColor: 'secondary.tint',
  },
  '.SingleDatePickerInput:hover .DateInput_input': !isInvalid && {
    borderColor: 'secondary.tint',
  },
  '.SingleDatePickerInput:focus-within .SingleDatePickerInput_calendarIcon': {
    borderColor: 'secondary.tint',
  },
  '.SingleDatePickerInput .DateInput_input': {
    width: '100%',
    height: '12',
    borderTop: 0,
    borderBottom: 0,
    borderLeft: 0,
    borderRight: 0,
    border: 'light',
    borderColor: isInvalid ? 'error' : 'border.base',
    borderRadius: 'base',
    '&:focus-visible': {
      outline: '0!important',
    },
  },
  '.SingleDatePickerInput .DateInput_input:hover': !isInvalid && {
    border: 'light',
    borderColor: 'secondary.tint',
  },
  '.SingleDatePickerInput .DateInput_input__focused': {
    border: 'light',
    borderColor: 'secondary.tint',
  },
  '.CalendarDay': {
    fontSize: 'sm',
  },
  '.CalendarDay__selected, .CalendarDay__selected:active, .CalendarDay__selected:hover': {
    background: 'primary.base',
    borderColor: 'primary.base',
  },
  '.CalendarDay__selected_span': {
    background: 'gray.100',
    borderColor: 'gray.200',
    color: 'primary.base',
  },
  '.CalendarDay__default': {
    _hover: {
      background: 'primary.light',
      borderColor: 'primary.light',
      color: 'white',
    },
  },
  '.CalendarDay__hovered_span, .CalendarDay__hovered_span:hover': {
    background: 'gray.100',
    borderColor: 'gray.200',
    color: 'primary.base',
  },
  '.DayPickerKeyboardShortcuts_show__bottomRight::before': {
    borderRightColor: 'gray.600',
  },
  '.DayPickerNavigation_button__default': {
    borderColor: 'transparent',
  },
  '.DayPickerNavigation_svg__horizontal': {
    fill: 'primary.base',
  },
  '.DayPicker__withBorder': {
    boxShadow: '0 0 0 1px var(--chakra-colors-gray-300)',
  },
  '.ant-picker-dropdown': {
    zIndex: 9999,
  },
});

export default {
  ReactDates: {
    baseStyle: base,
    sizes: {
      sm: {
        '.DayPicker_weekHeader': {
          top: '56px',
        },
        '.CalendarMonth_caption': {
          paddingTop: '18px',
          paddingBottom: '32px',
        },
        '.DayPickerNavigation_button__horizontalDefault': {
          top: '17px',
          padding: '4px 6px',
        },
        '.DateInput_input': {
          paddingLeft: '4',
          paddingRight: '4',
          fontWeight: 'normal',
          color: 'gray.800',
        },
        '.DateInput_input::placeholder': {
          color: 'gray.700',
        },
        '.DateRangePickerInput_arrow_svg': {
          width: '19px',
          height: '19px',
        },
        '.SingleDatePickerInput .DateInput_input': {
          fontSize: 'md',
          lineHeight: 'none',
        },
        '.DateRangePickerInput .DateInput_input': {
          height: 7,
          fontSize: 'xs',
          lineHeight: 'none',
        },
      },
    },
    defaultProps: {
      size: 'sm',
    },
  },
};
